<template>
    <div :style="{'min-height':minHeight}"  style="width:100%;background-color: rgba(0, 0, 0, 0.05);display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <div style="width:500px;padding:0px 10px;background-color: #fff;font-size: 14px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);border-radius: 3px;">
            <el-row style="height: 50px;color:#c40001;font-weight: 700;line-height: 50px;border-bottom: 2px dotted #c40001;">
                欢迎注册
            </el-row>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm" style="padding: 0 30px 0 20px;">
                <el-form-item 
                    style="margin-top:40px;"
                    label="邮箱地址" 
                    label-width="90px"
                    prop="email"
                >
                    <el-input maxlength="50" placeholder="请输入邮箱" v-model="ruleForm.email" clearable></el-input>
                </el-form-item>
                <el-form-item 
                    style="margin-top:40px;"
                    label="密码" 
                    label-width="90px"
                    prop="password"
                >
                    <el-input placeholder="请输入密码" autocomplete="off"  v-model="ruleForm.password" show-password clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;"
                    label="确认密码" 
                    label-width="90px"
                    prop="checkPassword"
                >
                    <el-input placeholder="请输入密码" autocomplete="off" v-model="ruleForm.checkPassword" show-password clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;"
                    label="姓名" 
                    label-width="90px"
                    prop="name"
                >
                    <el-input maxlength="10" placeholder="请输入姓名" v-model="ruleForm.name" clearable></el-input>
                </el-form-item>


                <el-form-item 
                    style="margin-top:40px;"
                    label="身份证号" 
                    label-width="90px"
                    prop="IDCard"
                >
                    <el-input placeholder="请输入身份证号" v-model="ruleForm.IDCard"  clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;position: relative;"
                    label="验证码" 
                    label-width="90px"
                    prop="vifyCode"
                >
                    <el-input style="width:200px;" placeholder="请输入验证码" v-model="ruleForm.vifyCode" clearable></el-input>
                    <img @click="getVierificationCode" width="100" :src="codeImgSrc" style="position: absolute;right:40px;top:5px;width:100px;height:30px;display:inline-block;cursor: pointer;">
                </el-form-item>

                <el-form-item label-width="0" style="margin-top:40px;display: flex;justify-content: center;align-items: center;">
                    <el-button style="width:200px;background-color: #c40001;border-color: #c40001;" type="primary" @click="submitForm('ruleForm')">注册</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default{
        name:'Register',
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请输入密码'));
                } else {
                if (this.ruleForm.checkPassword !== '') {
                    this.$refs.ruleForm.validateField('checkPassword');
                }
                callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
                } else {
                callback();
                }
            };
            return{
                ruleForm: {
                    email: '',
                    password:'',
                    checkPassword:'',
                    name:'',
                    IDCard:'',
                    vifyCode:'',
                },
                uuid:'',                
                rules: {
                    email: [
                            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                        ],
                        password: [
                            { validator: validatePass,required: true, trigger: 'blur' }
                        ],
                        checkPassword: [
                            { validator: validatePass2,required: true, trigger: 'blur' }
                        ],                       
                        name: [
                            { required: true, message: '请输入姓名', trigger: 'blur' },
                        ],
                        IDCard: [
                            { required: true, message: '请输入身份证号', trigger: 'blur' },
                        ],

                        vifyCode: [
                            { required: true, message: '请输入验证码', trigger: 'blur' },
                        ],

                },
                minHeight:'100%',
                codeImgSrc:'',
            }
        },
        methods:{
            submitForm:function(formName) {
                var that=this;
                this.$refs[formName].validate((valid) => {
                if (valid) {

                    this.$confirm('请确保所填信息真实有效, 是否继续注册?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        //注册 调用API
                        var arr = [];
                        var jsont = { "uuid": this.uuid, "ruleForm": this.ruleForm};
                        arr.push(jsont);

                        this.$axios.post(
                            this.Global.globalUrl+'/interface/register.ashx',
                            JSON.stringify(arr),
                            {
                                header: { 'content-type': 'application/x-www-form-urlencoded' }
                            })
                        .then((res) => {
                            if (res.data.err==0){
                                this.$message({                                 
                                    duration:3000,
                                    type: 'success',
                                    message: '注册成功!'
                                });
                                //路由到登录
                                this.$router.push({name: "Login"});  
                            }else{
                                this.$message({                                   
                                    duration:5000,
                                    type: 'error',
                                    message: res.data.errMsg
                                });
                            }
                        })
                        .catch(() => {
                        })
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消注册'
                    });          
                    });

                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            getVierificationCode:function(){
                var that=this;
                this.$axios.get(this.Global.globalUrl+'/interface/getVierifyCode.ashx')
                .then((res) => {
                    that.uuid = res.data.uuid; 
                    that.codeImgSrc = "data:image/png;base64," + res.data.img;                             
                     
                })
                .catch(() => {
                })
            },
        },
        mounted(){
            this.$nextTick(function () {
                this.minHeight = (document.documentElement.clientHeight -200)+'px';
                this.getVierificationCode();
            })
        }
    }
</script>